import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { FolderSearch, PackagePlus } from 'lucide-react';

import { Button } from '@codes/ui-kit';

interface EmptyMarketplaceProps {
    hasFilters?: boolean;
    onClearFilters?: () => void;
}

export const EmptyMarketplace = ({ hasFilters, onClearFilters }: EmptyMarketplaceProps) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    if (hasFilters) {
        return (
            <div className="flex flex-col items-center justify-center py-20 text-center">
                <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center mb-4">
                    <FolderSearch className="w-8 h-8 text-gray-400" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">{t('marketplace.empty.noResults.title')}</h3>
                <p className="text-sub text-sm mb-6 max-w-md">{t('marketplace.empty.noResults.description')}</p>
                <Button onClick={onClearFilters} variant="outline">
                    {t('marketplace.empty.clearFilters')}
                </Button>
            </div>
        );
    }

    return (
        <div className="flex flex-col items-center justify-center py-20 text-center">
            <div className="w-16 h-16 rounded-full bg-point/10 flex items-center justify-center mb-4">
                <PackagePlus className="w-8 h-8 text-point" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">{t('marketplace.empty.noProjects.title')}</h3>
            <p className="text-sub text-sm mb-6 max-w-md">{t('marketplace.empty.noProjects.description')}</p>
            <Button onClick={() => navigate('/home')}>{t('marketplace.empty.uploadProject')}</Button>
        </div>
    );
};
